import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function BlogIndex() {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const postsPerPage = 8; // 👈 show 8 per page (2 rows of 4)

  useEffect(() => {
    async function loadPosts() {
      const files = [
        "/blog/post1.md",
        "/blog/post2.md",
        "/blog/post3.md",
        //"/blog/post4.md",
        "/blog/post5.md",
        "/blog/post6.md",
        "/blog/post7.md",
        "/blog/post8.md",
      ];

      const loadedPosts = await Promise.all(
        files.map(async (file) => {
          const res = await fetch(file);
          const text = await res.text();

          const frontmatterMatch = text.match(/---\n([\s\S]*?)\n---/);
          let meta = {};
          if (frontmatterMatch) {
            const lines = frontmatterMatch[1].split("\n");
            lines.forEach((line) => {
              const [key, ...rest] = line.split(":");
              meta[key.trim()] = rest.join(":").trim().replace(/"/g, "");
            });
          }

          return {
            ...meta,
            slug: file.replace("/blog/", "").replace(".md", ""),
          };
        })
      );

      loadedPosts.sort((a, b) => new Date(b.date) - new Date(a.date));
      setPosts(loadedPosts);
    }

    loadPosts();
  }, []);

  // Pagination logic
  const indexOfLast = currentPage * postsPerPage;
  const indexOfFirst = indexOfLast - postsPerPage;
  const currentPosts = posts.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(posts.length / postsPerPage);

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <h1 className="text-5xl font-extrabold mb-12 tracking-tight ">
        Blog
      </h1>

      {/* Post Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {currentPosts.map((post) => (
          <div key={post.slug} className="group">
            {post.caption && (
              <Link to={`/blog/${post.slug}`}>
                <img
                  src={post.caption}
                  alt={post.title}
                  className="w-full h-[400px] object-cover shadow-md transition-transform duration-300 group-hover:scale-[1.02]"
                />
              </Link>
            )}
            <div className="mt-4">
              <p className="text-gray-500 text-xs">{post.date}</p>
              <h2 className="text-lg font-semibold mt-1">
                <Link
                  to={`/blog/${post.slug}`}
                  className="hover:text-gray-600 transition-colors"
                >
                  {post.title}
                </Link>
              </h2>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center space-x-3 mt-16">
          <button
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            disabled={currentPage === 1}
            className="px-4 py-2 rounded-lg bg-cyan-50 text-gray-700 hover:bg-cyan-100 disabled:opacity-50"
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => setCurrentPage(i + 1)}
              className={`px-4 py-2 rounded-lg ${
                currentPage === i + 1
                  ? "bg-cyan-600 text-white"
                  : "bg-cyan-50 text-gray-700 hover:bg-cyan-100"
              }`}
            >
              {i + 1}
            </button>
          ))}
          <button
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="px-4 py-2 rounded-lg bg-cyan-50 text-gray-700 hover:bg-cyan-100 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default BlogIndex;
